import React, { useRef } from 'react';

import { useIsOverflow } from '../../hooks/useIsOverflow';
import { ThemeProp } from '../../theme/Themes';
import Avatar from '../Avatar';
import TextTooltip from '../TextTooltip';
import {
  InfoBoxIcon,
  InfoBoxImageAndValuesContainer,
  InfoBoxImageContainer,
  InfoBoxTitle,
  InfoBoxValue,
  InfoBoxValueContainer,
  InfoBoxValuesContainer,
  VehicleInfoBoxContainer,
} from './VehicleCard.styles';
import { TextBox } from './VehicleTextBox';

export interface CompanyBox extends TextBox {
  imageUrl: string;
}

const VehicleCompanyBox = ({ data }: { data: CompanyBox }) => {
  const value1Ref = useRef();
  const isValue1Overflow = useIsOverflow(value1Ref);

  const value2Ref = useRef();
  const isValue2Overflow = useIsOverflow(value2Ref);

  return (
    <VehicleInfoBoxContainer>
      {data.title && <InfoBoxTitle>{data.title}</InfoBoxTitle>}
      <InfoBoxImageAndValuesContainer>
        {data.imageUrl && (
          <InfoBoxImageContainer>
            <Avatar size="sm" width="2.125rem" height="2.125rem" src={data.imageUrl} borderRadius="3.125rem" />
          </InfoBoxImageContainer>
        )}
        <InfoBoxValuesContainer $type="company">
          <InfoBoxValueContainer>
            {data.icon1 && <InfoBoxIcon>{data.icon1}</InfoBoxIcon>}
            {data.value1 && (
              <TextTooltip tooltipText={data.value1} isDisabled={!isValue1Overflow}>
                <InfoBoxValue ref={value1Ref}>{data.value1}</InfoBoxValue>
              </TextTooltip>
            )}
          </InfoBoxValueContainer>
          <InfoBoxValueContainer>
            {data.icon2 && <InfoBoxIcon>{data.icon2}</InfoBoxIcon>}
            {data.value2 && (
              <TextTooltip tooltipText={data.value2} isDisabled={!isValue2Overflow}>
                <InfoBoxValue ref={value2Ref} color={(props: ThemeProp) => props.theme.colors.greyscale.c050}>
                  {data.value2}
                </InfoBoxValue>
              </TextTooltip>
            )}
          </InfoBoxValueContainer>
        </InfoBoxValuesContainer>
      </InfoBoxImageAndValuesContainer>
    </VehicleInfoBoxContainer>
  );
};

export default VehicleCompanyBox;
